import dayjs from "dayjs";

const SEC_MS: number = 1000;
const MIN_MS: number = 60 * SEC_MS;
const HOR_MS: number = 60 * MIN_MS;
const DAY_MS: number = 24 * HOR_MS;

interface RemainingTime {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export const getRemainingMS = (timestamp: number): number =>
  timestamp - Date.now();

export const getRemainingTime = (remainingMS: number): RemainingTime => ({
  days: Math.floor(remainingMS / DAY_MS),
  hours: Math.floor((remainingMS % DAY_MS) / HOR_MS),
  minutes: Math.floor((remainingMS % HOR_MS) / MIN_MS),
  seconds: Math.floor((remainingMS % MIN_MS) / SEC_MS),
});

export const trackDurationFormatter = (seconds: number) => {
  return Math.floor(seconds / 60).toString() + ":" + (seconds % 60).toString();
};

export const timestampToString = (timestamp, format = "MMM D 'YY | HH:mm") => {
  const date = dayjs(timestamp);
  return date.format(format);
};
